export const dateToYearMonthDayString = (date: Date | null) => {
    if (!date) {
        return '';
    }

    return `${date.getFullYear()}-${((date.getMonth() || 0) + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};

const isInvalidDate = (date: Date): boolean => isNaN(date?.getTime());

export const toLocalDate = (input: string): string => {
    if (!input) {
        return '';
    }

    try {
        const parsedDate = new Date(input);
        if (isInvalidDate(parsedDate)) {
            const [day, month, year, time] = input.split(/[- ]/);
            const timeArray = time ? time.split(':').map(Number) : [];

            const date = new Date(+year, +month - 1, +day, ...timeArray);

            if (isInvalidDate(date)) {
                return '';
            }

            return date.toISOString();
        }
        return dateToYearMonthDayString(parsedDate);
    } catch (error) {
        console.warn('Failed to parse date', input, error);
        return '';
    }
};
